<template>
  <main :id="$style.main">
    <main-title
      :class="$style.main_title"
      :main_title="'この日この時'"
      :sub_title="'〜 History 〜'"
      :color="'#403f3f'"
      :align="'center'"
    ></main-title>
    <!-- <div :class="$style.description">
      松井秀喜選手に関する過去の新聞報道の中から星稜高校時代、読売巨人時代、メジャー時代の活躍の様子や記録、
      日々の足跡などファンの皆さんに月日別に紹介するページです。本ページで表示されるデータは、当日のデータを参照しています。
      当日のデータが存在しない場合もあります。
      1993年から2020年まで
    </div>-->
    <div id="calender_top" :class="$style.calender_top_c"></div>
    <history-menu></history-menu>
    <div :class="$style.pullup" v-scroll-to="'#calender_top'">
      <div :class="$style.arrow"></div>
    </div>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import HistoryMenu from "@/components/organsms/history/HistoryMenu.vue";

export default Vue.extend({
  name: "HistoryView",

  components: {
    MainTitle,
    HistoryMenu
  }
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  #main {
    background: #f2f2fd;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    height: 1200px;
    // height: auto;
    .description {
      text-align: center;
      margin: 40px 20px;
    }
    color: #403f3f;
  }
  .calender_top_c {
    position: absolute;
    top: 90px;
    // padding-top: 60px;
  }
  // .pullup {
  //   height: 40px;
  //   width: 40px;
  //   position: fixed;
  //   bottom: 30px;
  //   right: 20px;
  //   font-size: 14px;
  //   background: red;
  //   z-index: 3;
  // }
  .pullup {
    bottom: 30px;
    position: fixed;
    right: 20px;
    z-index: 3;
    width: 40px;
    height: 40px;
    // background: #3f98ef;
    background: rgba(51, 51, 51, 0.8);
    border-radius: 50%;
    .arrow {
      width: 20px;
      height: 20px;
      border: 5px solid;
      // border-color: #565656 #565656 transparent transparent;
      border-color: #fff #fff transparent transparent;
      transform: rotate(-45deg);
      margin: auto;
      margin-top: 15px;
    }
  }
}

@media only screen and (min-width: 1024px) {
  #main {
    background: #f2f2fd;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    height: 1000px;
    .description {
      width: 820px;
      text-align: center;
      margin: 40px 0;
    }
  }
}
</style>